import { Column } from 'components/Blocks';
import { WarningIcon } from 'components/Icons';

function ValidationError(): JSX.Element {
  return (
    <Column alignItems="center" className="text-warning">
      <WarningIcon size={54} />

      <p>Parece que ocorreu um erro de validação.</p>
    </Column>
  );
}

export default ValidationError;
